import type SmartSelectProperties from "./SmartSelect.properties.ts";
import { type ChangeEvent, useMemo } from "react";
import type { SelectType } from "../shared/select/Select.type.ts";

export const useSmartSelectController = (props: SmartSelectProperties) => {
  const selectedOption: SelectType[] = useMemo(
    () => props.data.filter((o) => props.selectedValue === o.value),
    [props],
  );

  const handleChange = (selected: { value: string; label: string } | null) => {
    if (selected) {
      props.handleChange({
        target: { value: selected.value },
      } as ChangeEvent<HTMLSelectElement>);
    }
  };

  return {
    selectedOption,
    handleChange,
  };
};
